import React from "react";
import { Link } from "react-router-dom";

const Title = (props) => {
  return (
    <header className="portfolio-detail-hero">
      <div className="portfolio-detail-hero__inner">
        <Link className="portfolio-detail-hero__back" to="/">
          <i className="fas fa-arrow-left" aria-hidden="true" />
          All collections
        </Link>
        <p className="portfolio-detail-hero__eyebrow">Arpita’s Makeover · Portfolio</p>
        <h1>{props.imageType} Pictures</h1>
        <p className="portfolio-detail-hero__description">
          A closer look at the artistry, details, and moments that make every look yours.
        </p>
        <div className="portfolio-detail-hero__ornament" aria-hidden="true">
          <span />
          <i className="fas fa-star" />
          <span />
        </div>
      </div>
    </header>
  );
};

export default Title;
